import { Input } from 'src/components/Input';
import { SkillCard } from './SkillCard';
import { Button } from 'src/components/Button';
import Checkbox from 'src/components/Checkbox';
import { X } from '@phosphor-icons/react';

type EndCallConfig = {
  phrases?: string[];
  signals_intent?: boolean;
};

export const validateEndCallConfig = (
  config: EndCallConfig | undefined,
): boolean => {
  if (!config || !config.phrases) {
    return false;
  }
  const phrases = config.phrases.filter((p) => !!p.trim());
  if (phrases.length !== config.phrases.length) {
    return false;
  }
  return phrases.length > 0;
};

export function EndCallSkill({
  config,
  onConfigChange,
}: {
  config: EndCallConfig;
  onConfigChange?: (config: EndCallConfig) => void;
}) {
  const phrases = config.phrases || [''];
  return (
    <SkillCard description="Set the closing messages the agent uses before hanging up.">
      <div className="mb-4 gap-2 flex flex-col items-start">
        {phrases.map((phrase, index) => (
          <div key={index} className="w-full flex gap-2 items-center">
            <Input
              label="Phrase"
              placeholder="Enter phrase"
              value={phrase}
              onChange={(e) =>
                onConfigChange?.({
                  ...config,
                  phrases: phrases.map((p, i) =>
                    i === index ? e.target.value : p,
                  ),
                })
              }
              required
              className="flex-1"
            />
            {phrases.length > 1 && (
              <Button
                variant="text"
                size="small"
                onClick={() => {
                  const newPhrases = phrases.filter((_, i) => i !== index);
                  onConfigChange?.({ ...config, phrases: newPhrases });
                }}
                className="p-2 mt-6 text-neutral-400 hover:text-error"
              >
                <X className="h-4 w-4" />
              </Button>
            )}
          </div>
        ))}
        <Button
          onClick={() =>
            onConfigChange?.({ ...config, phrases: [...phrases, ''] })
          }
          variant="text"
          size="small"
          className="mt-4 ml-0"
        >
          + Add more
        </Button>
      </div>
      <div className="mb-4 flex items-center gap-2">
        <Checkbox
          ariaLabel="Signals Intent"
          checked={config.signals_intent ?? true}
          onChange={(checked) =>
            onConfigChange?.({ ...config, signals_intent: checked })
          }
        />
        <span className="text-sm text-neutral-600">
          Detect when the caller wants to end the call
        </span>
      </div>
    </SkillCard>
  );
}
